import React from "react";
import { Typography, styled } from "@material-ui/core";
import { typography } from "../../theme/material-ui-theme";

const DocumentBox = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(12),
  "& p": {
    marginBottom: "1em"
  },
  "& h1": {
    ...typography.h5,
    marginBottom: "1rem"
  },
  "& ul": {
    padding: 0,
    margin: 0,
    display: `flex`,
    flexDirection: `column`,
    listStyle: `none`,
    "& li": {
      display: `flex`,
      flexDirection: `row`,
      alignItems: `flex-start`,
      "&:before": {
        content: `""`,
        display: `flex`,
        flexDirection: `row`,
        flex: `0 0 auto`,
        height: `5px`,
        width: `5px`,
        marginTop: `10px`,
        marginRight: `18px`,
        marginLeft: `8px`,
        backgroundColor: `#bcb9b3`
      }
    }
  }
}));

export default function PageDocument({ html }: { html: string }) {
  return (
    <DocumentBox>
      <Typography
        component="div"
        dangerouslySetInnerHTML={{
          __html: html
        }}
      />
    </DocumentBox>
  );
}
